export function getLocalTime() {
  throw new Error('getLocalTime called on the client!');
}
